import React, { createContext, useState, useEffect } from "react";
import { Auth } from 'models/auth';
import { checkCurrentMaintenanceStatus } from "api/generalApi";
import useApi from "hooks/useApi";
import { Platform } from "models/api/platform";

type AuthContextType = {
    isAuthenticated: boolean;
    fetchGeneralInfo: () => Promise<void>;
    hasEmergency: boolean | null;
    login: () => void;
    logout: () => void;
    auth: Auth,
};

export const AuthContext = createContext<AuthContextType>({} as AuthContextType);

export const AuthProvider = ({ children }: React.PropsWithChildren) => {
    const [auth] = useState<Auth>({} as Auth);
    const api = useApi()

    const login = () => {
      localStorage.setItem( 'auth', 'true' )
    };

    const logout = () => {
      localStorage.removeItem( 'auth' )
    };
    const isAuthenticated = !!localStorage.getItem('auth');

    const [hasEmergency, setEmergency] = useState<null | boolean>(null)

    const fetchGeneralInfo = async () => {
      try {
        const { data } = await checkCurrentMaintenanceStatus(api)

        if (data) {
          setEmergency(data.some(item => item.platform === Platform.All));
          return
        }

        setEmergency(false);
      } catch (e) {
        console.error('Request error: ', e)
      }
    };

    useEffect( () => {
      if (!isAuthenticated) {
        return
      }

      fetchGeneralInfo()
    }, []);

    return (
      <AuthContext.Provider value={{ isAuthenticated, auth, login, logout, hasEmergency, fetchGeneralInfo }}>
        {children}
      </AuthContext.Provider>
    );
};
